import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Loader from 'kepler/lib/components/Loader';
import i18n from '../../lib/reacti18n';
import { ICF_GUIDE } from '../constants/PropTypesShapes';
import routeDidUpdate from '../actions/actions-router';
import { icfClicked } from '../actions/action-icf-page';
import getHistory from '../../lib/HistoryHelper';
import Breadcrumb from './Breadcrumb';
import Page from '../../lib/page';
import ErrorPanel from '../components/ErrorPanel';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import UrlResources from '../constants/UrlResources';

const icfTopic = {
  payPalGuide: i18n.message('smarthelp/home.home.payPalGuide'),
  payPalGuideDescription: i18n.message('smarthelp/home.home.guideDescription'),
  backToHome: i18n.message('smarthelp/home.home.back.icf.articles'),
};
const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);

class IcfTopicContainer extends Component {
  constructor(props) {
    super(props);
    this.goToIcfArticlesPage = this.goToIcfArticlesPage.bind(this);
  }

  // Common function to get parsed icf-guide item.
  getParsedIcfItem(icfGuide) {
    return (
      <li key={icfGuide.icf_id} className="icf-guide-list">
        <a // eslint-disable-line jsx-a11y/no-static-element-interactions
          className="icf-title"
          tabIndex="0"
          onKeyPress={() => this.goToIcfArticlesPage(icfGuide.icf_id, icfGuide.icf_title)}
          onClick={() => this.goToIcfArticlesPage(icfGuide.icf_id, icfGuide.icf_title)}
        >
          {icfGuide.icf_title}
        </a>
      </li>
    );
  }

  goToIcfArticlesPage(icfId, icfTitle) {
    const icfUrl = Page.getFormattedUrlForArticle(icfTitle, icfId);
    // FPTI for icf-id click in icf topic page
    trackLink({ id: 'ICFTopic', link: `smarthelp-icf-topic|${UrlResources.PAYPALGUIDE}|${icfId}|${icfTitle}`, hpid: icfId });
    this.props.icfClicked(icfId);
    this.props.routeDidUpdate({ pathname: `/${UrlResources.PAYPALGUIDE}/${icfUrl}` });
    getHistory().push(`/${UrlResources.PAYPALGUIDE}/${icfUrl}`);
  }

  renderIcfGuides() {
    const { icfGuides, icfLoading, icfGuidesError } = this.props;

    if (icfLoading) {
      return <Loader show type="fixed" />;
    } if (icfGuidesError) {
      trackPage({ id: 'ICFTopic', link: 'smarthelp-icf-topics-error' });
      return <ErrorPanel pageName="icfTopicErrorPage" />;
    }

    const listItems = icfGuides.map((icfGuide) => this.getParsedIcfItem(icfGuide));
    const articleDocIds = icfGuides.map((icf) => icf.icf_id).join('|');
    trackPage({ id: 'ICFTopic', link: 'smarthelp-icf-topics', article_doc_id: articleDocIds });

    return (
      <div className="icf-topic-page">
        <Breadcrumb items={[{ path: '/home', title: label }]} />
        <h1 className="icf-guide-title">{icfTopic.payPalGuide}</h1>
        <div className="paypal-guide-description">{icfTopic.payPalGuideDescription}</div>
        <div className="icf-guides">
          <ul>{listItems}</ul>
        </div>
      </div>
    );
  }

  render() {
    return this.renderIcfGuides();
  }
}

IcfTopicContainer.propTypes = {
  icfGuides: PropTypes.arrayOf(PropTypes.shape(ICF_GUIDE)),
  routeDidUpdate: PropTypes.func.isRequired,
  icfClicked: PropTypes.func.isRequired,
  icfLoading: PropTypes.bool.isRequired,
  icfGuidesError: PropTypes.bool.isRequired,
};

IcfTopicContainer.defaultProps = {
  icfGuides: [],
};

function mapStateToProps(state) {
  return {
    icfGuides: state.allICFGuides.icfGuidesResponse,
    icfLoading: state.allICFGuides.icfLoading,
    icfGuidesError: state.allICFGuides.icfGuidesError,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ routeDidUpdate, icfClicked }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(IcfTopicContainer);
